import React from "react";
import { useNavigate } from "react-router-dom";
import SeriesStatsPage from "./SeriesStatsPage";

const AdminStatsPage = () => {
  const navigate = useNavigate();
  return <SeriesStatsPage onBack={() => navigate("/")} />;
};

export default AdminStatsPage;
